<template>
    <b-card :title="title">
        <b-card-header>
            <b-card-body>
                <div class="buttons">
                    <b-tabs>
                        <b-tab title="Inventory Transfer">
                            <b-card-body>
                                <b-row>
                                    <label>Warehouse/Location:</label>
                                    <b-col v-show="!islocationSection">
                                        <b-form-select id="input_location" v-model="selectWarehouse" :options="locations"
                                            value-field="id" text-field="name" block>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    Select All
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <label>Officer:</label>
                                    <b-col v-show="!isOfficerSection">
                                        <b-form-select id="input-1" v-model="selectofficer" :options="users"
                                            value-field="id" text-field="name" block>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    Select All
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>

                                </b-row>
                                <div class="d-flex mt-3">
                                    <label>Reason:</label>
                                    <b-col v-show="!isSectionSection">
                                        <b-form-textarea id="input-reason" v-model="reason" :options="sections"
                                            value-field="id" text-field="name" placeholder="" block>
                                        </b-form-textarea>
                                    </b-col>
                                </div>
                                <b-button @click="apply" size="lg" :to="``" class="mt-4" variant="primary">
                                    Apply To All
                                </b-button>
                                <p class="mt-3">
                                    Page: {{ currentPage }} of {{ Math.ceil(rows / itemsPerPage) }} Total:
                                    {{ rows }}
                                </p>
                                <b-form @submit.stop.prevent="onSubmit">
                                    <b-table v-model="tabledata" :per-page="itemsPerPage" :current-page="currentPage"
                                        :fields="itemFields" striped hover :busy="transfertableLoading" responsive
                                        :items="transferItems" class="mt-3">
                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>
                                        <template #cell(product_name)="{ item }">
                                            <label for="" class="mt-4">{{ item.name }}</label>
                                        </template>
                                        <template #cell(item_code)="{ item }">
                                            <label for="" class="mt-4">{{ item.ext_reference_code }}</label>
                                        </template>
                                        <template #cell(uom)="{ item }">
                                            <label for="" class="mt-4">{{ item.uom }}</label>
                                        </template>


                                        <template #cell(Quantity)="{ item }">
                                            <b-form-input required v-model="quantityData[item.id]"
                                                class="mt-4"></b-form-input>
                                        </template>
                                        <template #cell(from)="{ item }">
                                            <label for="" class="mt-4">{{ computedValue(item, isChecked[item.id]) }}</label>
                                            <!-- <b-form-input readonly :value="computedValue(item, isChecked[item.id])"></b-form-input> -->
                                        </template>

                                        <!-- <template #cell(isofficer)="{ item }">
                                            <b-form-checkbox v-model="isChecked[item.id]"></b-form-checkbox>
                                        </template> -->

                                        <template #cell(tolocation)="{ item }">
                                            <b-form-checkbox v-model="isChecked[item.id]">Officer</b-form-checkbox>
                                            <b-form-select
                                             v-model="locationData[item.id]"
                                                :disabled="isLocationDisabled(item.id).disabled"

                                                :value="selectedWarehouse"
                                                :options="locations"
                                                 @change="fetchSection(item)"
                                                required value-field="id"
                                                text-field="name" block>
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select All
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </template>

                                        <template #cell(tosection)="{ item }">
                                            <b-form-select class="mt-4" v-if="isChecked[item.id]"
                                                v-model="officerData[item.id]"
                                                :options="users"
                                                 required value-field="id"
                                                text-field="name" block>
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select All
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>

                                            <b-form-select v-else class="mt-4" v-model="sectionData[item.id]"
                                                value-field="id"
                                                 :options="fetchSection(item)" text-field="name" block>
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select All
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>

                                        </template>

                                        <template #cell(reason)="{ item }">
                                            <b-form-input class="mt-4" v-model="reasonData[item.id]" required
                                                :value="otherTextBoxValue" :id="'input-reason-' + item.id" value-field="id"
                                                text-field="name" block>
                                            </b-form-input>
                                        </template>

                                    </b-table>

                                    <div>
                                        <b-button size="lg" :to="``" variant="primary" type="submit"
                                            class="mt-4 float:right">
                                            Complete Transfer
                                        </b-button>
                                    </div>
                                </b-form>
                                <b-row>
                                    <b-col>
                                        <b-pagination class="float-right" v-model="currentPage" :total-rows="rows"
                                            :per-page="itemsPerPage" aria-controls="roleTable" pills
                                            align="right"></b-pagination>
                                    </b-col>
                                </b-row>
                                <portal-target name="transfer">
                                </portal-target>
                            </b-card-body>
                        </b-tab>

                        <b-tab title="Inventory History">
                            <b-card-body>
                                <div class="d-flex col-3">

                                    <label>Product:</label>
                                    <b-form-input id="input-product" v-model="model.product_search" @keyup="fetchData" value-field="id" text-field="name"
                                    placeholder="Keyword Search" block>
                                    <!-- <b-col v-show="!islocationSection">
                                        <b-form-select id="input_location" @change="fetchData" v-model="selectedProductId"
                                            :options="products" value-field="id" text-field="name" block>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    Select All
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col> -->
                                </b-form-input>
                                </div>
                                <b-row class="mt-4">

                                    <label for="date" class="mt-1">Date Range:</label>
                                    <b-col md="3" class="ml-5" cols="12">
                                        <b-form-group id="fieldset-created_start" label="From Date:"
                                            label-for="input-created_start" label-cols="3">
                                            <b-form-input type="date" @change="fetchData" id="input-created_start"
                                                v-model="model.created_start"></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="3" cols="12">
                                        <b-form-group id="fieldset-created_end" label="To Date:"
                                            label-for="input-created_end" label-cols="3">
                                            <b-form-input type="date" @change="fetchData" id="input-created_end"
                                                v-model="model.created_end"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <download-excel :fields="json_fields" :data="historytabledataExport"
                                        name="inventory-history.xls">
                                        <b-button class="">Export</b-button>
                                    </download-excel>
                                </b-row>

                                <!-- <label for="fromdate" class="ml-5" >From Date:</label> -->
                                <!-- <b-datepicker id="dateFrom"  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" v-model="selectedFromDate" @change="fetchData"></b-datepicker> -->
                                <!-- <input type="date" id="fromdate-input" v-model="selectedFromDate"  @change="fetchData"> -->
                                <!-- <label for="todate" class="ml-5" >To Date:</label> -->
                                <!-- <b-datepicker id="dateTo" v-model="selectedToDate" @change="fetchData"></b-datepicker> -->
                                <!-- <input type="date" id="todate-input" v-model="selectedToDate" @change="fetchData"> -->
                                <p class="mt-3">
                                    Page: {{ currentPage }} of {{ Math.ceil(historyrows / itemsPerPage) }} Total:
                                    {{ historyrows }}
                                </p>
                                <b-table v-model="historytabledata" :per-page="historyitemsPerPage"
                                    :current-page="currentPage" :fields="historyitemFields" striped hover
                                    :busy="historytableLoading" responsive :items="historyItems" class="mt-3">
                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                </b-table>
                                <b-row>
                                    <b-col>
                                        <b-pagination class="float-right" v-model="currentPage" :total-rows="historyrows"
                                            :per-page="historyitemsPerPage" aria-controls="roleTable" pills
                                            align="right"></b-pagination>
                                    </b-col>
                                </b-row>


                                <portal-target name="history"></portal-target>
                            </b-card-body>
                        </b-tab>
                    </b-tabs>
                </div>


            </b-card-body>
        </b-card-header>

    </b-card>
</template>

<script>
import moment from 'moment';
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'


const defaultModel = Object.freeze({
    created_start: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    created_end: moment().format('YYYY-MM-DD'),
})

const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    name: 'transferSectionItems-ListItems',
    props: ['type', 'title'],
    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            model: { ...defaultModel },
            product_search:'',
            transfertableLoading: false,
            historytableLoading: false,
            tabledata: [],
            historytabledata: [],
            reason: '',
            selectedFromDate: '',
            selectedProductId: '',
            selectedLocation: '',
            selectedToDate: '',
            locationData: [],
            quantityData: [],
            officerData: [],
            sectionData: [],
            reasonData: [],
            tolocation: '',
            selectSection: [],
            otherTextBoxValue: '',
            isofficer: '',
            isChecked: {},
            selectofficer: '',
            selectedofficer: '',
            selectWarehouse: "",
            selectedWarehouse: "",
            itemsPerPage: 15,
            historyitemsPerPage: 15,
            currentPage: 1,
            isOfficerSection: false,
            islocationSection: false,
            istypeSection: false,
            isProductSection: false,
            isSectionSection: false,
            section_id: null,
            location_id: null,
            type_id: null,
            user_id: null,
            itemFields: [
                {
                    key: 'product_name',
                    label: 'Product Name',
                    // formatter: (value, key, item) =>
                    //     item.name

                },

                {
                    key: 'item_code',
                    label: 'item Code',
                },
                {
                    key: 'uom',
                    label: 'UOM',


                },
                {
                    key: 'Quantity',
                    label: 'Quantity',
                    formatter: (value, key, item) =>
                        item.sections[0] && item.sections[0].quantity_on_hand
                    ,
                },
                {
                    key: 'From',
                    label: 'from',
                },
                // {
                //     key: 'isofficer',
                //     label: 'Is Officer ?',
                // },

                {
                    key: 'tolocation',
                    label: 'To Location',

                },
                {
                    key: 'tosection',
                    label: 'To Section/Officer',

                },
                {
                    key: 'reason',
                    label: 'Reason',

                },



            ],
            json_fields: {
                "Product Name": "name",
                "Item Code": "itemcode",
                "Item Type": "type",
                "UOM": "uom",
                "Quantity": "quantity",
                "From Warehouse/Location/Section Officer": "location",
                "To Warehouse/Location/Section Officer": "officer",
                "QTY Transfer": "qtransfer",
                "Note": "note",

            },
            historyitemFields: [
                {
                    key: 'Product Name',
                    label: 'Product Name',
                    formatter: (value, key, item) =>
                        item.name
                    ,
                },

                {
                    key: 'item Code',
                    label: 'item Code',
                    formatter: (value, key, item) =>
                        item.ext_reference_code
                    ,
                },
                {
                    key: 'Item Type',
                    label: 'Item Type',
                    formatter: (value, key, item) =>
                        item.type.name
                    ,
                },
                {
                    key: 'UOM',
                    label: 'UOM',
                    formatter: (value, key, item) =>
                        item.uom
                    ,
                },
                {
                    key: 'Quantity',
                    label: 'Quantity',
                    formatter: (value, key, item) =>
                        item.sections[0] && item.sections[0].quantity_on_hand
                    ,
                },
                {
                    key: 'From',
                    label: 'From Warehouse/Location/Section Officer',
                    formatter: (value, key, item) => `${item.sections[0] && item.sections[0].location_section.location.name} /${item.sections[0] && item.sections[0].location_section.officers[0] && item.sections[0].location_section.offic[0].first_name}`,
                },

                {
                    key: 'To',
                    label: 'To Warehouse/Location/Section Officer',


                },
                {
                    key: 'Qty Transfer',
                    label: 'QTY Transfer',


                },
                {
                    key: 'Note',
                    label: 'Note    ',


                },






            ],


        }
    },
    watch: {

        dateRange: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.model.created_start = moment().subtract(30, 'days').format('YYYY-MM-DD');
                    this.model.created_end = moment().format('YYYY-MM-DD');
                    break;
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment().subtract(31, 'days').format('YYYY-MM-DD');
                    this.model.created_end = moment().subtract(1, 'days').format('YYYY-MM-DD');
                    break;
                default:
                    break;
            }
        },

        // selectWarehouse: function(selectedWarehouseId){
        //     const data =  JSON.parse(localStorage.storedData)
        //     data.forEach((item) => {
        //         this.locationData[item.id] = selectedWarehouseId
        //     })
        // },

        // selectofficer: function(selectedOfficerId){
        //     const data =  JSON.parse(localStorage.storedData)
        //     console.log("selectofficer",selectedOfficerId )
        //     data.forEach((item) => {
        //         this.officerData[item.id] = selectedOfficerId
        //     })
        // },

        // reason: function(selectedReason){
        //     console.log("reason",selectedReason )
        //     const data =  JSON.parse(localStorage.storedData)
        //     data.forEach((item) => {
        //         this.reasonData[item.id] = selectedReason
        //     })
        // },

        historyItems: {
            handler: function () {
                this.historytableLoading = false
            },
        },


    },
    computed: {
        defaultFromDate() {
            return moment().subtract(30, 'days').toDate(); // 30 days ago from today
        },
        defaultToDate() {
            return new Date(); // today's date
        },

        transferItems() {
            const transferdata = JSON.parse(localStorage.storedData)
            // console.log("tranferdata............",transferdata)
            return transferdata
        },

        historyItems() {
            const _historyitems = this.$store.state.masterItem.historyItems;
            return _historyitems

        },

        sectionItems() {
            return this.$store.state.masterItem

        },

        locations() {
            console.log('locations', this.$store.state.locations)
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            )
        },
        sections() {
            const { location_id } = this
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },

        rows() {
            const data = JSON.parse(localStorage.storedData).length
            // console.log('...........length',data)
            //this.tableLoading = false
            return data
        },
        historyrows() {
            const historyitemRows = this.$store.state.masterItem.historyItems.length;
            return historyitemRows
        },


        products() {

            const _items = this.$store.state.masterItem.section_items;
            return _items
        },
        users() {
            return this.$store.getters['users/all_admin_users'].map(x => {
                x.name = x.first_name + ' ' + x.last_name
                return x
            })
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },

        historytabledataExport() {
            var exportData = [];

            this.$store.state.masterItem.historyItems.forEach((item) => {
                var exportItem = {};
                exportItem.name = item.type && item.type.name
                exportItem.code = item.ext_reference_code
                exportItem.type = item.type && item.type.name
                exportItem.uom = item.uom
                exportItem.quantity = item.sections[0] && item.sections[0].quantity_on_hand
                exportItem.location = `${item.sections[0] && item.sections[0].location_section.location.name} /${item.sections[0] && item.sections[0].location_section.officers[0] && item.sections[0].location_section.offic[0].first_name}`
                exportItem.officer = ''
                exportItem.qtransfer = ''
                exportItem.note = ''

                exportData.push(exportItem)
            });


            return exportData
        }

    },

    created() {
        this.selectedFromDate = this.defaultFromDate;
        this.selectedToDate = this.defaultToDate;
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('masterItem/fetchSection')
        this.$store.dispatch('masterItem/fetchallMaster')
        this.$store.dispatch('users/fetchAll')
        const ids = []
        const data = JSON.parse(localStorage.storedData)
        data.forEach((item) => {
            ids.push(item.id)
        })
        // const locationid =``
        const from_date = `${this.model.created_start}`
        const to_date = `${this.model.created_end}`
        this.historytableLoading = true
        this.$store.dispatch('masterItem/fetchHistory', { ids, from_date, to_date })

    },
    methods: {
        isLocationDisabled(id) {
    console.log("......log.......", !this.selectedWarehouse);
    if (!this.selectedWarehouse) {
        return {
            disabled: this.isChecked[id],
            // officer: this.officerData[id] = this.selectedofficer,
            // location: this.locationData[id]
        };
    } else {
        return {
            disabled: this.isChecked[id],
            // officer: this.officerData[id] = this.selectedofficer,
            // selectedWarehouse:this.selectedWarehouse,
            location: this.locationData[id]
        };
    }
}

,


        // isOfficerDisabled(id) {
        //     return !this.isChecked[id];
        // },
        computedValue(item, isChecked) {
            if (isChecked) {
                // this.officerData[item.id] = this.selectedofficer;
                return item.sections[0] && item.sections[0].location_section.officers[0] && item.sections[0].location_section.officers[0].first_name
            } else {
                // this.locationData[item.id] = this.selectWarehouse
                return item.sections[0] && item.sections[0].location_section.location.name
            }
        },

        async fetchData() {
            console.log("......................")
            // const ids = []
            // const data =  JSON.parse(localStorage.storedData)
            // data.forEach((item) => {
            // ids.push(`${this.selectedProductId}`)
            // })
            // const locationid =`${this.selectedLocation}`
            const ids = [`${this.selectedProductId}`]
            const product_search = `${this.model.product_search}`
            const from_date = `${this.model.created_start}`
            const to_date = `${this.model.created_end}`
            this.historytableLoading = true
            this.$store.dispatch('masterItem/fetchHistory', {
                ids,
                from_date,
                to_date,
                product_search
            })
        },
        // apply() {
        //     this.otherTextBoxValue = this.reason
        //     this.selectedofficer = this.selectofficer
        //     this.selectedWarehouse = this.selectWarehouse
        //     JSON.parse(localStorage.storedData).forEach((item) => {
        //         this.reasonData[item.id] = this.reason
        //         if (this.isChecked[item.id]) {
        //             this.officerData[item.id] = this.selectedofficer
        //         } else {
        //             this.locationData[item.id] = this.selectedWarehouse
        //             console.log("this.locationData[item.id]", this.locationData[item.id])
        //         }
        //     })

        // },
        apply() {
            this.otherTextBoxValue = this.reason
            this.selectedofficer = this.selectofficer
            this.selectedWarehouse = this.selectWarehouse
            JSON.parse(localStorage.storedData).forEach(item => {
                this.reasonData[item.id] = this.reason
                if (this.isChecked[item.id]) {
                    this.officerData[item.id] = this.selectofficer
                } else {
                    this.locationData[item.id] = this.selectedWarehouse
                }
            })
        },  
        fetchSection(item) {
console.log("item",this.locationData[item.id])

            const location_id = this.locationData[item.id]
            console.log("this.locationData[item.id]", this.locationData[item.id])
            const data = ((this.$store.state.locations.locations.find(
                x => x.id == location_id
            ) || {}
            ).sections || []
            ).filter(x => !x.is_officer)
            return data

            // console.log("..........section..........",this.$store.state.locations.locations)
            // // const { location_id } = this
            // console.log("location_id", this.locationData[item.id])
            // const { location_id }= this.locationData[item.id]
            // return (
            //     (
            //         this.$store.state.locations.locations.find(
            //             x => x.id == location_id
            //         ) || {}
            //     ).sections || []
            // ).filter(x => !x.is_officer)
        },
       async onSubmit() {
            //this.loading = true
            //var orderData = [];
            try {
                var orderData = {
                    orders: []
                };
                const data = JSON.parse(localStorage.storedData)
                data.forEach((item) => {
                    var order = {};
                    console.log("item::", this.sectionData[item.id])
                    order.master_item_id = parseFloat(item.id)
                    order.quantity = parseFloat(this.quantityData[item.id])

                    if (this.isChecked[item.id]) {
                        order.from_section_id = item.sections[0] && item.sections[0].location_section.location.id
                        order.to_section_id = null

                    } else {
                        if (item.sections[0] && item.sections[0].location_section.location.id == '') {
                            order.from_section_id = item.sections[0] && item.sections[0].location_section_id;
                        } else {
                            order.from_section_id = item.sections[0] && item.sections[0].location_section.location.id
                        }
                        order.to_section_id = parseInt(this.sectionData[item.id])
                    }

                    if (this.isChecked[item.id]) {
                        order.from_officer_id = null
                        order.to_officer_id = parseFloat(this.officerData[item.id])

                    } else {
                        order.from_officer_id = null
                        order.to_officer_id = null
                    }



                    // if (this.isChecked[item.id]) {
                    //     order.from_officer_id = null
                    //     order.to_officer_id =parseFloat(this.officerData[item.id])
                    // }else{
                    //     order.from_officer_id = null
                    //     order.to_officer_id =parseFloat(this.officerData[item.id])
                    // }

                    //order.to_section_id = this.locationData[item.id]
                    // if (this.isChecked[item.id]) {
                    //     order.to_section_id = null
                    // }else{
                    //     order.to_section_id = this.locationData[item.id]?this.locationData[item.id]:0
                    // }

                    // order.to_section_id = null

                    // order.from_officer_id = null
                    //order.from_officer_id = (item.sections[0]&&item.sections[0].location_section.officers[0]&&item.sections[0].location_section.officers[0].id)?item.sections[0].location_section.officers[0].id:0;
                    // order.to_officer_id = parseFloat(this.officerData[item.id])
                    order.notes = this.reasonData[item.id]

                    orderData.orders.push(order)
                });
                console.log("transfer", orderData);
                const path = 'masterItem/transfer'
                const res =  this.$store.dispatch(path, orderData)
                console.log('response:', await res)
                this.doToast('Suceess!', "Transfer successfully", 'success')
                // console.log("...........model.........", orderData)
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.loading = false
            }
        }

    }
}

</script>
<style>
.nav-tabs {
    justify-content: center
}
</style>